export function initContactCalendarPopup() {
  if (!document.querySelector('[data-cal-link="troy/contactus"][data-cal-namespace="contactus"]')) {
    return;
  }

  (function (C, A, L) {
    const enqueue = function (api, args) {
      api.q.push(args);
    };
    const document = C.document;

    C.Cal = C.Cal || function () {
      const cal = C.Cal;
      const args = arguments;

      if (!cal.loaded) {
        cal.ns = cal.ns || {};
        cal.q = cal.q || [];
        const script = document.createElement("script");

        script.addEventListener("load", () => {
          document.querySelectorAll('[data-cal-link="troy/contactus"][data-cal-namespace="contactus"]').forEach((trigger) => {
            trigger.addEventListener("click", (event) => {
              event.preventDefault();
            });
          });
        });
        script.src = A;
        document.head.appendChild(script);
        cal.loaded = true;
      }

      if (args[0] === L) {
        const namespace = args[1];
        const initNamespace = function () {
          const api = function () {
            enqueue(api, arguments);
          };

          api.q = api.q || [];
          return api;
        };

        if (typeof namespace === "string") {
          cal.ns[namespace] = cal.ns[namespace] || initNamespace();
          enqueue(cal.ns[namespace], args);
        } else {
          enqueue(cal, args);
        }
        return;
      }

      enqueue(cal, args);
    };
  })(window, "https://cal.troyonline.com/embed/embed.js", "init");

  const Cal = window.Cal;
  Cal("init", "contactus", {origin:"https://cal.troyonline.com"});
  Cal.ns["contactus"]("ui", {
    styles: {branding: {brandColor: "#000000"}},
    hideEventTypeDetails: false,
    layout: "month_view"
  });
}
